import { OptionService } from './option';
import { HttpService } from './http';
import { RequestService } from './request';
import { ResponseService } from './response';
import { RouterService } from './router';
export function sheetbase(options) {
    var Option = new OptionService(options);
    var Router = new RouterService(Option);
    var Request = new RequestService();
    var Response = new ResponseService(Option);
    var HTTP = new HttpService(Option, Response, Router);
    return {
        Option: Option,
        Router: Router,
        Request: Request,
        Response: Response,
        HTTP: HTTP
    };
}
